<template>
    <div class="container">
        <articulo/>
    </div >
</template>
<script>
import articulo from '@/components/articulo.vue'

export default {
    components:{
        articulo
    } 
}
</script>